import {
    createBrowserRouter,
    createRoutesFromElements,
    Route,
} from "react-router-dom";

import Root from "../application/layouts/Root";
//Routes

import commonRoutes from "./commonRoutes";
import mainRoutes from "./mainRoutes";

const router = createBrowserRouter(
    createRoutesFromElements(
        <Route path="/" element={<Root />}>

            {/* Single Page with no Navigation bars and Side Bars */}
            {commonRoutes}

            {/* Page with Navigationbars , SideBars and Footers */}
            {mainRoutes}
        </Route>
    )
);

export default router;